// FIXME: Need to be refactored
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import useStyles from '../../styles/stationStyle'
import gas from '../../constants/icons/gasStation.svg'
import time from '../../constants/icons/timeOutline.svg'
import engineOutline from '../../constants/icons/engineOutline.svg'
import {
  LinearProgress,
  TableCell,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableContainer
} from '@material-ui/core'

/**
 * The GroupStationMobile' container.
 */
const GroupStationMobile = ({ mobileStations }) => {
  const [stationOrdened, setStationOrdened] = useState([])
  const [maxValueProgressLinear, setMaxValueProgressLinear] = useState(0)
  const classes = useStyles()

  useEffect(() => {
    dataOrder()
  }, [])

  const orderDesc = (a, b) => {
    if (a.time_queue_server > b.time_queue_server) {
      return -1
    } else if (a.time_queue_server < b.time_queue_server) {
      return 1
    } else {
      return 0
    }
  }

  const dataOrder = () => {
    const tops = mobileStations.table.sort(orderDesc)
    setStationOrdened(tops)
    setMaxValueProgressLinear(tops[0].time_queue_server)
  }

  return (
    <TableContainer style={{ margin: 5, height: 'auto', paddingRight: 10 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headCell}>Estación Móvil</TableCell>
            <TableCell className={classes.headCell} align="center">
              Tiempo entre abastecimientos
            </TableCell>
            <TableCell className={classes.headCell} align="center" colSpan={2}>
              Abastecimientos (Nº)
              {/* <img src={help} alt={'help'} /> */}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stationOrdened.map(station => {
            return (
              <TableRow key={station.station}>
                <TableCell size="small">
                  <Typography className={station.time_queue_server !== 0 ? classes.nameZeroMobile : classes.nameCell}>
                    {station.station}
                  </Typography>
                </TableCell>
                <TableCell align="left" size="small">
                  <Typography
                    className={station.time_queue_server !== 0 ? classes.nameZeroMobile : classes.nameCell}
                    style={{ display: 'flex' }}
                  >
                    <img src={time} alt="time" className={classes.icons} />
                    {parseInt(station.time_queue_server)} min
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={((station.time_queue_server - 0) * 100) / (maxValueProgressLinear - 0)}
                  />
                </TableCell>
                <TableCell size="small">
                  <Typography
                    className={station.time_queue_server !== 0 ? classes.nameZeroMobile : classes.nameCell}
                    style={{ display: 'flex' }}
                  >
                    <img src={gas} alt="gas" className={classes.icons} />
                    <small>{station.total_fuel_truck_charges_server}</small>
                  </Typography>
                </TableCell>
                <TableCell size="small">
                  <Typography
                    className={station.time_queue_server !== 0 ? classes.nameZeroMobile : classes.nameCell}
                    style={{ display: 'flex' }}
                  >
                    <img src={engineOutline} alt="engineOutline" className={classes.icons} />
                    <small>{station.total_fuel_other_charges_server}</small>
                  </Typography>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

GroupStationMobile.propTypes = {
  mobileStations: PropTypes.object
}

export default GroupStationMobile
